import { useTranslation } from "react-i18next";

import { LandingPageEventType } from "pages/Dashboard/types";
import { RelatedEventGroup } from "pages/shared/Dashboard/types";

import MatchingTextHighlight from "features/ui/MatchingTextHighlight";

interface Props {
  config: RelatedEventGroup;
  event: LandingPageEventType;
  matchedData?: Record<string, string[]> | null;
  getDisplayLabel: (
    accessor: string,
    defaultLabel: string,
    suffix?: string
  ) => string;
  searchTerm?: string;
}

const DefaultEventFieldText = ({
  config,
  event,
  getDisplayLabel,
}: Pick<Props, "config" | "event" | "getDisplayLabel">) => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 flex flex-col gap-4">
      {config.comparisonFields.map((field, index) => (
        <div key={index}>
          <div className="font-bold">{getDisplayLabel(field, field)}</div>
          <div>
            {event[field as keyof LandingPageEventType]?.toString() ??
              t("common:not_available")}
          </div>
        </div>
      ))}
    </div>
  );
};

export const MatchedText = ({
  event,
  config,
  matchedData,
  getDisplayLabel,
  searchTerm,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex-3 pl-4">
      {!matchedData ? (
        <DefaultEventFieldText
          config={config}
          event={event}
          getDisplayLabel={getDisplayLabel}
        />
      ) : (
        <div className="flex flex-col gap-4">
          <>
            {config.comparisonFields.map((field, index) =>
              matchedData?.[field] ? (
                <div key={index}>
                  <div className="font-bold">
                    {getDisplayLabel(field, field)}
                  </div>
                  <div>
                    <MatchingTextHighlight
                      text={
                        event[
                          field as keyof LandingPageEventType
                        ]?.toString() ?? t("common:not_available")
                      }
                      searchTerms={matchedData?.[field]}
                      secondarySearchTerms={
                        searchTerm ? [searchTerm] : undefined
                      }
                    />
                  </div>
                </div>
              ) : (
                <div key={index}>
                  <div className="font-bold">
                    {getDisplayLabel(field, field)}
                  </div>
                  <div>
                    {event[field as keyof LandingPageEventType]?.toString() ??
                      t("common:not_available")}
                  </div>
                </div>
              )
            )}
            {Object.entries(matchedData).map(
              ([key, value], index) =>
                !config.comparisonFields.includes(key) && (
                  <div key={index}>
                    <div className="font-bold">{getDisplayLabel(key, key)}</div>
                    <div>
                      <MatchingTextHighlight
                        text={
                          event[
                            key as keyof LandingPageEventType
                          ]?.toString() ?? t("common:not_available")
                        }
                        searchTerms={value}
                        secondarySearchTerms={
                          searchTerm ? [searchTerm] : undefined
                        }
                      />
                    </div>
                  </div>
                )
            )}
          </>
        </div>
      )}
    </div>
  );
};
